var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"accordion"},_vm._l((_vm.rmodel),function(item){return _c('li',{key:item.id,class:[item.opened && item.active ? 'open': '', item.active ? 'byl-accordion-active' : '']},[_c('item',{attrs:{"model":item},on:{"route-changed":_vm.routeChanged}})],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ee3b7f3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/accordion/index.vue
// module id = null
// module chunks = 